const cardSliders = [...document.querySelectorAll('.js-card-slider')];

cardSliders.forEach((cardSlider) => {
    const slider = cardSlider.querySelector('.js-card-slider__slider');
    const filters = [...cardSlider.querySelectorAll('.js-card-slider__filter')];

    const flkty = new window.Flickity(slider, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        cellSelector: '.js-card-slider-item',
        // freeScroll: true,
    });

    const scrollBar = cardSlider.querySelector('.js-card-slider-scroll-bar');
    const scrollBarWidth = scrollBar.offsetWidth;

    const filtersValues = filters.map(filter => (filter.value === '' ? '.' : filter.value));

    filters.forEach((filter, filterIndex) => {
        filter.addEventListener('change', () => {
            filtersValues[filterIndex] = filter.value === '' ? '.' : filter.value;

            const category = filtersValues.join('\\|');
            const regexp = new RegExp(category);

            flkty.cells.forEach((cell) => {
                cell.element.style.display = '';
            });

            flkty.cells
                .filter(cell => !regexp.test(cell.element.dataset.category))
                .forEach((cell) => {
                    cell.element.style.display = 'none';
                });

            flkty.reloadCells();
        });
    });

    // Add a tracking scrollbar
    if (scrollBar) {
        let scrolling = false;
        let mouseClickOffset = 0;
        let x = 0;

        flkty.on('select', (index) => {
            window.requestAnimationFrame(() => {
                if (!scrolling) {
                    x = (flkty.size.width - scrollBarWidth) * (index / (flkty.cells.length - 1));
                }
            });
        });

        scrollBar.addEventListener('mousedown', (event) => {
            const rect = scrollBar.getBoundingClientRect();

            mouseClickOffset = event.clientX - rect.left;
            scrolling = true;
            scrollBar.classList.add('is-scrolling');
        });

        document.body.addEventListener('mouseup', () => {
            const percentage = x / (flkty.size.width - scrollBarWidth);
            const index = Math.floor(percentage * flkty.cells.length);
            const constrainedIndex = Math.min(flkty.cells.length - 1, Math.max(0, index));

            scrolling = false;

            flkty.select(constrainedIndex);
            scrollBar.classList.remove('is-scrolling');
        });

        document.body.addEventListener('mousemove', (event) => {
            if (scrolling) {
                x = event.clientX - (mouseClickOffset * 2);
                const index = Math.floor((x / slider.offsetWidth) * flkty.cells.length);
                flkty.select(index);
            }
        });

        // eslint-disable-next-line no-inner-declarations
        function scrollBarPosition() {
            scrollBar.style.transform = `translateX(${x}px)`;

            window.requestAnimationFrame(scrollBarPosition);
        }

        scrollBarPosition();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/cardSlider.js